import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryShowcase() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            探索小熊世界
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            六大品类，随心探索。找到属于你的那一份黄油小熊温暖。
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?tab=${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-background-50 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-200">
                <i className={`${cat.icon} text-2xl md:text-3xl text-primary-500`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 mt-1">{cat.count} 款好物</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}